import { render, staticRenderFns } from "./ShiftInput.vue?vue&type=template&id=ddf3c8ea&"
import script from "./ShiftInput.vue?vue&type=script&lang=js&"
export * from "./ShiftInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports